var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path3, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _path4, _path5, _path6, _path7, _path8, _path9, _rect37, _rect38, _rect39, _rect40, _rect41, _path10, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _path11, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWodcom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 643.87 115.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#ffffff;}.cls-1,.cls-3{stroke:#ffffff;stroke-miterlimit:10;}.cls-1{stroke-width:3px;}.cls-3{fill:none;stroke-width:0.75px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.73,2.71a54.8,54.8,0,0,1,30.76,9.4,55.05,55.05,0,0,1,19.94,24.21,55.24,55.24,0,0,1,0,42.83,55.2,55.2,0,0,1-29.28,29.28,55.24,55.24,0,0,1-42.83,0A55.19,55.19,0,0,1,12.11,88.49a54.8,54.8,0,0,1-9.4-30.76c0-1.51.07-3,.19-4.55.09-1.09.21-2.19.37-3.27A55,55,0,0,1,57.73,2.71m0-1.21A56.24,56.24,0,0,0,2.07,49.73c-.16,1.11-.29,2.23-.38,3.35-.13,1.53-.19,3.09-.19,4.65A56.24,56.24,0,1,0,57.73,1.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.69,
    y: 78.76,
    width: 27.35,
    height: 0.51,
    transform: "translate(-50.78 41.68) rotate(-47.16)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.17,
    y: 68.82,
    width: 0.51,
    height: 19.23,
    transform: "translate(-13.8 7.44) rotate(-10.55)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.05,
    y: 88.21,
    width: 22.15,
    height: 0.51,
    transform: "translate(-4.56 1.37) rotate(-2.97)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.55,
    y: 80.52,
    width: 17,
    height: 0.51,
    transform: "translate(-67 76.5) rotate(-76.46)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.59,
    y: 64.25,
    width: 0.51,
    height: 12.91,
    transform: "translate(-60.09 61.42) rotate(-73.82)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,72.76a.25.25,0,0,1-.24-.19.25.25,0,0,1,.18-.31L31.6,68.74a.26.26,0,0,1,.31.19.25.25,0,0,1-.19.3L17.1,72.76Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 44.23,
    y: 58.07,
    width: 0.51,
    height: 25.97,
    transform: "translate(-32.75 103.66) rotate(-80.84)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42.51,
    y: 82.51,
    width: 21.07,
    height: 0.51,
    transform: "translate(-44.07 97.95) rotate(-66.23)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 60.91,
    y: 71.21,
    width: 0.51,
    height: 9.72,
    transform: "translate(-36.41 78.59) rotate(-52.68)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 63.81,
    y: 73.9,
    width: 20.58,
    height: 0.51,
    transform: "translate(-26.24 43.8) rotate(-28.19)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73.88,
    y: 72.72,
    width: 0.51,
    height: 19.47,
    transform: "translate(-29.21 122.64) rotate(-69.29)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.89,
    y: 79.01,
    width: 0.51,
    height: 20.28,
    transform: "translate(-1.01 0.74) rotate(-0.65)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 63.04,
    y: 92.34,
    width: 22.42,
    height: 0.51,
    transform: "translate(-40.61 62.67) rotate(-36.67)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.95,
    y: 69.29,
    width: 0.51,
    height: 16.61,
    transform: "translate(-0.36 0.38) rotate(-0.26)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 91.48,
    y: 64.72,
    width: 0.51,
    height: 20.63,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -21.65, 109.51)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.15,
    y: 67.36,
    width: 0.51,
    height: 28.97,
    transform: "translate(-28.79 56.06) rotate(-29.95)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.18,
    y: 81.79,
    width: 0.51,
    height: 16.71,
    transform: "translate(-33.17 122.19) rotate(-59.44)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.02,
    y: 96.94,
    width: 18.47,
    height: 0.51,
    transform: "translate(-20.19 19.47) rotate(-13.17)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.85,
    y: 95.39,
    width: 0.51,
    height: 15.92,
    transform: "matrix(0.51, -0.86, 0.86, 0.51, -53.56, 112.74)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.25,
    y: 104.09,
    width: 26.99,
    height: 0.51,
    transform: "translate(-35.23 27.33) rotate(-21.98)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.4,
    y: 85.46,
    width: 21.04,
    height: 0.51,
    transform: "translate(-41.54 55.84) rotate(-39.54)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.45,
    y: 87.6,
    width: 0.51,
    height: 22.09,
    transform: "translate(-21.56 11.24) rotate(-13.22)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27.1,
    y: 91.54,
    width: 9.97,
    height: 0.51,
    transform: "translate(-59.76 59.83) rotate(-51.55)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 34.35,
    y: 93.68,
    width: 0.51,
    height: 17.73,
    transform: "translate(-57.22 45.26) rotate(-39.39)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20.77,
    y: 83.74,
    width: 0.51,
    height: 17.26,
    transform: "translate(-72.3 76.12) rotate(-67.3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.93,72.53h-.05l-16.76-3a.24.24,0,0,1-.2-.29.25.25,0,0,1,.29-.21L100,72a.25.25,0,0,1,.21.29A.25.25,0,0,1,99.93,72.53Z"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 99.89,
    y: 71.41,
    width: 9.8,
    height: 0.51,
    transform: "translate(-8.14 13.66) rotate(-7.18)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.16,
    y: 70.95,
    width: 26.15,
    height: 0.51,
    transform: "translate(-9.67 11.05) rotate(-8.42)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.94,
    y: 80.25,
    width: 26.6,
    height: 0.51,
    transform: "translate(-36.93 39.24) rotate(-33.74)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 53.75,
    y: 105.43,
    width: 15.06,
    height: 0.51,
    transform: "translate(-60.83 101.84) rotate(-58.09)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.78,
    y: 86.93,
    width: 0.51,
    height: 17.84,
    transform: "translate(-53.41 111.45) rotate(-67.29)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35,
    y: 100.65,
    width: 19.03,
    height: 0.51,
    transform: "translate(-65.62 95.2) rotate(-63.23)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.74,
    y: 82.97,
    width: 0.51,
    height: 14.35,
    transform: "translate(-56.79 101.65) rotate(-71.66)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.24,
    y: 75.66,
    width: 13.48,
    height: 0.51,
    transform: "translate(-22.49 99.02) rotate(-46.15)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 92.03,
    y: 87.33,
    width: 13.88,
    height: 0.51,
    transform: "translate(-6.06 167.81) rotate(-78.88)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.58,
    y: 100.99,
    width: 13.05,
    height: 0.51,
    transform: "translate(-41.17 144.58) rotate(-70.82)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 83.24,
    y: 94.49,
    width: 14.4,
    height: 0.51,
    transform: "translate(-4.43 4.44) rotate(-2.74)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.99,
    y: 85.9,
    width: 0.51,
    height: 9.18
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.84,54.85A6.18,6.18,0,0,0,61,58a6,6,0,0,0,1.83,4.45,6.35,6.35,0,0,0,4.62,1.79h.36v1.37h-.45a7.6,7.6,0,0,1-6-2.54,7.69,7.69,0,0,1-1.86-5.2,7.22,7.22,0,0,1,2.25-5.39,7.74,7.74,0,0,1,5.63-2.19h.47v1.44h-.45a6.46,6.46,0,0,0-3.23.84A6,6,0,0,0,61.84,54.85Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.93,52.43a7.59,7.59,0,0,0-4.57-2.13,9.18,9.18,0,0,0-1.06,0h-.47v15.3h.45a9.51,9.51,0,0,0,1.08-.06,7.25,7.25,0,0,0,5-2.49,7.68,7.68,0,0,0,1.86-5.2A7.23,7.23,0,0,0,52.93,52.43Zm-1.12,10a6.15,6.15,0,0,1-3.45,1.7V51.77a6.46,6.46,0,0,1,2.16.75,6,6,0,0,1,2.3,2.25A6.23,6.23,0,0,1,53.64,58,6,6,0,0,1,51.81,62.41Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.21,50.27,19.11,61,14.88,50.27h-.31L10.3,61,7.25,50.27H5.72l4.1,14.49.13.44h.28l0-.1L14.74,53.9l4.43,11.3h.28l4.24-14.77,0-.16H22.21Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.58,50.27a7.76,7.76,0,0,1,5.68,2.26A7.85,7.85,0,0,1,34.7,65.94a7.61,7.61,0,0,1-5.6-2.27,7.48,7.48,0,0,1-2.29-5.5,8,8,0,0,1,1-4,7.71,7.71,0,0,1,6.73-3.91Zm.07,1.45a6.36,6.36,0,0,0-5.46,3.19,6.4,6.4,0,0,0-.83,3.26,6.27,6.27,0,0,0,6.29,6.32,6.39,6.39,0,0,0,3.21-.84,6,6,0,0,0,2.31-2.31A6.46,6.46,0,0,0,41,58.1a6.36,6.36,0,0,0-.83-3.22,6.2,6.2,0,0,0-2.33-2.3A6.39,6.39,0,0,0,34.65,51.72Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.93,50.25a7.8,7.8,0,0,1,5.68,2.26A7.88,7.88,0,0,1,74.45,63.65a7.46,7.46,0,0,1-2.28-5.5,7.86,7.86,0,0,1,1-4A7.53,7.53,0,0,1,76,51.29,7.69,7.69,0,0,1,79.93,50.25ZM80,51.7a6.18,6.18,0,0,0-3.14.86,6.32,6.32,0,0,0-2.32,2.33,6.53,6.53,0,0,0-.83,3.26A6.28,6.28,0,0,0,80,64.48a6.37,6.37,0,0,0,3.21-.85,6,6,0,0,0,2.31-2.3,6.52,6.52,0,0,0,.83-3.25,6.36,6.36,0,0,0-.83-3.22,6.27,6.27,0,0,0-2.33-2.3A6.36,6.36,0,0,0,80,51.7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109,65.22l-.26-.93-3.83-13.51-.13-.47h-.27l0,0-.13.33L100,61.6,95.53,50.31h-.27L91.07,64.88l-.1.35h1.52l3.1-10.75,4.23,10.75h.31l4.28-10.75,3,10.75H109Z"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 78.61,
    y: 37.14,
    width: 27.35,
    height: 0.51,
    transform: "translate(2.11 79.63) rotate(-47.15)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.97,
    y: 28.36,
    width: 0.51,
    height: 19.23,
    transform: "translate(-5.58 15.51) rotate(-10.55)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.45,
    y: 27.69,
    width: 22.15,
    height: 0.51,
    transform: "translate(-1.33 4.72) rotate(-2.97)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 91.1,
    y: 35.38,
    width: 17,
    height: 0.51,
    transform: "translate(41.64 124.13) rotate(-76.47)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 103.55,
    y: 39.25,
    width: 0.51,
    height: 12.91,
    transform: "translate(30.99 132.66) rotate(-73.82)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83,47.68a.26.26,0,0,1-.25-.2.25.25,0,0,1,.19-.3l14.62-3.52a.24.24,0,0,1,.3.18.25.25,0,0,1-.18.31L83.05,47.67Z"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 69.92,
    y: 32.37,
    width: 0.51,
    height: 25.97,
    transform: "translate(14.22 107.42) rotate(-80.84)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 51.06,
    y: 33.39,
    width: 21.07,
    height: 0.51,
    transform: "matrix(0.4, -0.92, 0.92, 0.4, 5.97, 76.46)"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 53.23,
    y: 35.49,
    width: 0.51,
    height: 9.72,
    transform: "translate(-11.03 58.42) rotate(-52.68)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.26,
    y: 42,
    width: 20.58,
    height: 0.51,
    transform: "translate(-15.15 24.16) rotate(-28.18)"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.26,
    y: 24.22,
    width: 0.51,
    height: 19.47,
    transform: "translate(-5.58 59.84) rotate(-69.29)"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.25,
    y: 17.12,
    width: 0.51,
    height: 20.28,
    transform: "translate(-0.31 0.56) rotate(-0.65)"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.19,
    y: 23.56,
    width: 22.42,
    height: 0.51,
    transform: "translate(-6.23 28.84) rotate(-36.68)"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.19,
    y: 30.51,
    width: 0.51,
    height: 16.61,
    transform: "translate(-0.18 0.15) rotate(-0.26)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.66,
    y: 31.06,
    width: 0.51,
    height: 20.63,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -24.22, 37.39)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24,
    y: 20.08,
    width: 0.51,
    height: 28.97,
    transform: "translate(-14.02 16.72) rotate(-29.95)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.96,
    y: 17.91,
    width: 0.51,
    height: 16.71,
    transform: "matrix(0.51, -0.86, 0.86, 0.51, -10.71, 33.76)"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.16,
    y: 18.97,
    width: 18.47,
    height: 0.51,
    transform: "translate(-3.32 9.71) rotate(-13.17)"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42.29,
    y: 5.1,
    width: 0.51,
    height: 15.92,
    transform: "translate(9.63 43.01) rotate(-59.37)"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.41,
    y: 11.81,
    width: 26.99,
    height: 0.51,
    transform: "translate(-0.02 24.05) rotate(-21.98)"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.21,
    y: 30.45,
    width: 21.04,
    height: 0.51,
    transform: "translate(-6.34 43.78) rotate(-39.54)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.69,
    y: 6.72,
    width: 0.51,
    height: 22.09,
    transform: "translate(-2.02 18.06) rotate(-13.22)"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.58,
    y: 24.36,
    width: 9.97,
    height: 0.51,
    transform: "translate(11.95 73.98) rotate(-51.55)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.79,
    y: 5,
    width: 0.51,
    height: 17.73,
    transform: "translate(9.39 53.95) rotate(-39.39)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 93.37,
    y: 15.42,
    width: 0.51,
    height: 17.26,
    transform: "translate(35.32 101.14) rotate(-67.3)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.48,47.37h0l-16.76-3a.25.25,0,0,1-.21-.29.27.27,0,0,1,.3-.21l16.76,3a.24.24,0,0,1,.2.29A.25.25,0,0,1,31.48,47.37Z"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.96,
    y: 44.49,
    width: 9.8,
    height: 0.51,
    transform: "translate(-5.52 1.58) rotate(-7.18)"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.34,
    y: 44.95,
    width: 26.15,
    height: 0.51,
    transform: "translate(-6.14 6.99) rotate(-8.42)"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.11,
    y: 35.65,
    width: 26.6,
    height: 0.51,
    transform: "translate(-8.42 44.04) rotate(-33.74)"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.84,
    y: 10.47,
    width: 15.06,
    height: 0.51,
    transform: "translate(16.05 50.36) rotate(-58.09)"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.36,
    y: 11.64,
    width: 0.51,
    height: 17.84,
    transform: "translate(16.4 65.77) rotate(-67.29)"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 60.62,
    y: 15.26,
    width: 19.03,
    height: 0.51,
    transform: "translate(24.69 71.14) rotate(-63.23)"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.4,
    y: 19.09,
    width: 0.51,
    height: 14.35,
    transform: "translate(24.87 86.97) rotate(-71.66)"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.93,
    y: 40.24,
    width: 13.48,
    height: 0.51,
    transform: "translate(-26.24 19.42) rotate(-46.15)"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.74,
    y: 28.57,
    width: 13.88,
    height: 0.51,
    transform: "matrix(0.19, -0.98, 0.98, 0.19, -15.63, 38.65)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27.03,
    y: 14.91,
    width: 13.05,
    height: 0.51,
    transform: "translate(8.2 41.87) rotate(-70.82)"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.01,
    y: 21.42,
    width: 14.4,
    height: 0.51,
    transform: "translate(-1.01 1.18) rotate(-2.74)"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.15,
    y: 21.33,
    width: 0.51,
    height: 9.18
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.21,8.88h4.15L130.61,38,142.18,8.88H143L154.46,38l8.39-29.09H167l-11.6,40.37h-.75l-12-30.55L130.41,49.25h-.75Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M193.68,7.86A20.94,20.94,0,0,1,209,14a20.37,20.37,0,0,1,6.18,15.07,20.49,20.49,0,0,1-6.16,15,20.45,20.45,0,0,1-15,6.18,20.66,20.66,0,0,1-15.16-6.15,20.22,20.22,0,0,1-6.18-14.88,21.54,21.54,0,0,1,2.81-10.78,20.78,20.78,0,0,1,18.2-10.6Zm.18,3.93a16.62,16.62,0,0,0-8.5,2.33,16.8,16.8,0,0,0-6.26,6.29,17.44,17.44,0,0,0-2.26,8.82,16.48,16.48,0,0,0,5,12.15,16.44,16.44,0,0,0,12,5,17.29,17.29,0,0,0,8.7-2.28,16.31,16.31,0,0,0,6.24-6.23A17.57,17.57,0,0,0,211,29a17.13,17.13,0,0,0-2.24-8.7,16.75,16.75,0,0,0-6.31-6.22A17,17,0,0,0,193.86,11.79Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.53,8.88h8a48.37,48.37,0,0,1,9.11.55A10.37,10.37,0,0,1,246.53,13a10.05,10.05,0,0,1,2.25,6.66,10.82,10.82,0,0,1-1.55,5.8,9.63,9.63,0,0,1-4.43,3.78,20.28,20.28,0,0,1-8,1.3l14.52,18.75h-5L229.85,30.5h-2.29V49.25h-4Zm4,3.95V26.55l7,.06a17.36,17.36,0,0,0,6-.77,6.17,6.17,0,0,0,3-2.46,6.76,6.76,0,0,0,1.09-3.77,6.53,6.53,0,0,0-1.1-3.69,6.15,6.15,0,0,0-2.89-2.38,17.68,17.68,0,0,0-5.93-.71Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.43,8.88h4V45.35H277v3.9H257.43Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.39,49.25V8.88h8.37q9.06,0,13.15,1.45a17.51,17.51,0,0,1,9.18,7.14,21.63,21.63,0,0,1,3.31,12.1,21.21,21.21,0,0,1-2.62,10.68A16.9,16.9,0,0,1,308,47.06q-4.19,2.19-11.73,2.19Zm3.87-3.81h4.67q8.37,0,11.61-1a13.33,13.33,0,0,0,7.16-5.33,16.41,16.41,0,0,0,2.61-9.42,17.24,17.24,0,0,0-2.83-10A14.21,14.21,0,0,0,302.61,14q-3.8-1.15-12.49-1.15h-2.86Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M360,7.86A20.92,20.92,0,0,1,375.36,14a20.34,20.34,0,0,1,6.19,15.07,20.49,20.49,0,0,1-6.17,15,20.43,20.43,0,0,1-15,6.18,20.67,20.67,0,0,1-15.16-6.15A20.22,20.22,0,0,1,339,29.24a21.45,21.45,0,0,1,2.82-10.78,20.43,20.43,0,0,1,7.67-7.79A20.7,20.7,0,0,1,360,7.86Zm.18,3.93a16.56,16.56,0,0,0-8.49,2.33,16.75,16.75,0,0,0-6.27,6.29,17.54,17.54,0,0,0-2.26,8.82,16.48,16.48,0,0,0,5,12.15,16.44,16.44,0,0,0,12,5,17.26,17.26,0,0,0,8.7-2.28,16.31,16.31,0,0,0,6.24-6.23A17.47,17.47,0,0,0,377.37,29a17,17,0,0,0-2.24-8.7,16.68,16.68,0,0,0-6.31-6.22A17,17,0,0,0,360.19,11.79Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M389.64,8.88h20.23v3.95H393.68V25.48h16.19v3.95H393.68V49.25h-4Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M432.46,49.25V8.88h8.37q9.06,0,13.15,1.45a17.51,17.51,0,0,1,9.18,7.14,21.71,21.71,0,0,1,3.31,12.1,21.32,21.32,0,0,1-2.62,10.68A16.9,16.9,0,0,1,457,47.06q-4.19,2.19-11.73,2.19Zm3.87-3.81H441q8.37,0,11.61-1a13.37,13.37,0,0,0,7.16-5.33,16.41,16.41,0,0,0,2.61-9.42,17.24,17.24,0,0,0-2.83-10A14.2,14.2,0,0,0,451.67,14q-3.78-1.15-12.48-1.15h-2.86Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M473.71,8.88h4V49.25h-4Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M526,15.66l-3.13,3a24.1,24.1,0,0,0-7.4-5,19.94,19.94,0,0,0-7.84-1.71,18.73,18.73,0,0,0-9,2.33,17,17,0,0,0-6.66,6.33A16.34,16.34,0,0,0,489.52,29,16.7,16.7,0,0,0,492,37.63a17.32,17.32,0,0,0,6.75,6.45,19.46,19.46,0,0,0,9.44,2.34,16.15,16.15,0,0,0,10.54-3.51,13.86,13.86,0,0,0,5.1-9.11H510.93V29.9h17.4q0,9.36-5.55,14.86t-14.73,5.51q-11.21,0-17.73-7.63a20.29,20.29,0,0,1-5-13.59,20.88,20.88,0,0,1,2.88-10.68,20.42,20.42,0,0,1,7.9-7.72,23,23,0,0,1,11.37-2.79,25.36,25.36,0,0,1,9.66,1.85A29,29,0,0,1,526,15.66Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M535.44,8.88h4V49.25h-4Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M544.72,12.83V8.88h22.12v3.95h-9V49.25h-4.12V12.83Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M589.16,8.88,608,49.25h-4.36L597.28,36h-17.4L573.6,49.25h-4.51L588.17,8.88Zm-.51,8.57-6.92,14.62h13.8Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M614.24,8.88h4V45.35h15.54v3.9H614.24Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.69,73.78l-3.19,2.45a17.31,17.31,0,0,0-6.32-5.2,18.57,18.57,0,0,0-8.12-1.77,17.94,17.94,0,0,0-8.94,2.31,16.64,16.64,0,0,0-6.38,6.24,17.21,17.21,0,0,0-2.27,8.79,16.52,16.52,0,0,0,5.07,12.33,17.54,17.54,0,0,0,12.77,4.94,18,18,0,0,0,14.19-6.65l3.19,2.42a20.44,20.44,0,0,1-7.54,5.94,23.63,23.63,0,0,1-10.09,2.1q-10.59,0-16.71-7.05a21.3,21.3,0,0,1-5.13-14.38,20,20,0,0,1,6.21-14.92,21.43,21.43,0,0,1,15.58-6,22.88,22.88,0,0,1,10.21,2.23A19.8,19.8,0,0,1,158.69,73.78Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186,65.28a20.94,20.94,0,0,1,15.35,6.12,21.45,21.45,0,0,1,0,30.11,21.59,21.59,0,0,1-30.2,0A20.18,20.18,0,0,1,165,86.66a21.58,21.58,0,0,1,2.81-10.79A20.8,20.8,0,0,1,186,65.28Zm.18,3.92a17.23,17.23,0,0,0-14.76,8.63,17.38,17.38,0,0,0-2.26,8.81,17,17,0,0,0,17,17.12,17.29,17.29,0,0,0,8.7-2.28,16.27,16.27,0,0,0,6.24-6.24,17.52,17.52,0,0,0,2.24-8.79,17.12,17.12,0,0,0-2.24-8.69,16.68,16.68,0,0,0-6.31-6.22A17,17,0,0,0,186.19,69.2Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.8,106.67l5.78-40.38h.66l16.41,33.13,16.26-33.13h.64l5.81,40.38h-4l-4-28.88-14.28,28.88h-1l-14.45-29.1-4,29.1Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.46,106.67l5.78-40.38h.65l16.42,33.13,16.25-33.13h.65L311,106.67h-4l-4-28.88L288.8,106.67h-1l-14.45-29.1-4,29.1Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.09,66.29h4V90.66a49.67,49.67,0,0,0,.17,5.41,9.05,9.05,0,0,0,1.4,4,8.27,8.27,0,0,0,3.37,2.69,10.63,10.63,0,0,0,4.59,1.08,9,9,0,0,0,3.84-.85,8.57,8.57,0,0,0,3.07-2.36A9.71,9.71,0,0,0,341.38,97a30.66,30.66,0,0,0,.41-6.32V66.29h4V90.66a29.93,29.93,0,0,1-1.05,8.75,11.92,11.92,0,0,1-4.23,5.8,12.08,12.08,0,0,1-7.67,2.47,14.72,14.72,0,0,1-8.37-2.33,11.23,11.23,0,0,1-4.67-6.18,32.9,32.9,0,0,1-.74-8.51Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M355.79,106.67V66.29h.88l26.87,30.95V66.29h4v40.38h-.91L360,76.09v30.58Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.77,66.29h4v40.38h-4Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.65,73.78l-3.18,2.45a17.42,17.42,0,0,0-6.33-5.2A18.5,18.5,0,0,0,430,69.26a18,18,0,0,0-8.95,2.31,16.71,16.71,0,0,0-6.38,6.24,17.2,17.2,0,0,0-2.26,8.79,16.54,16.54,0,0,0,5.06,12.33,17.58,17.58,0,0,0,12.78,4.94,18,18,0,0,0,14.19-6.65l3.18,2.42a20.33,20.33,0,0,1-7.53,5.94,23.63,23.63,0,0,1-10.09,2.1q-10.59,0-16.71-7.05a21.26,21.26,0,0,1-5.14-14.38,20,20,0,0,1,6.22-14.92,21.43,21.43,0,0,1,15.58-6,22.88,22.88,0,0,1,10.21,2.23A19.77,19.77,0,0,1,447.65,73.78Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M472.25,66.29l18.82,40.38h-4.35l-6.35-13.29H463l-6.29,13.29h-4.5l19.08-40.38Zm-.51,8.58-6.92,14.62h13.8Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M493.33,70.24V66.29h22.12v3.95h-9v36.43h-4.11V70.24Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M520.69,66.29h4v40.38h-4Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M553.2,65.28a20.92,20.92,0,0,1,15.35,6.12,21.45,21.45,0,0,1,0,30.11,21.59,21.59,0,0,1-30.2,0,20.18,20.18,0,0,1-6.18-14.87A21.49,21.49,0,0,1,535,75.87,20.76,20.76,0,0,1,553.2,65.28Zm.18,3.92a17.26,17.26,0,0,0-14.76,8.63,17.38,17.38,0,0,0-2.26,8.81,17,17,0,0,0,17,17.12,17.29,17.29,0,0,0,8.7-2.28,16.27,16.27,0,0,0,6.24-6.24,17.52,17.52,0,0,0,2.24-8.79,17.12,17.12,0,0,0-2.24-8.69A16.61,16.61,0,0,0,562,71.54,17,17,0,0,0,553.38,69.2Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M582.86,106.67V66.29h.88l26.87,30.95V66.29h4v40.38h-.91L587,76.09v30.58Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M620.24,99.15l3.43-2.06q3.63,6.66,8.38,6.67a8,8,0,0,0,3.81-1,6.69,6.69,0,0,0,2.72-2.54,6.59,6.59,0,0,0,.93-3.37,6.84,6.84,0,0,0-1.37-4,32.51,32.51,0,0,0-6.92-6.48q-5.06-3.81-6.28-5.52a10.06,10.06,0,0,1-2.14-6.17,9.41,9.41,0,0,1,1.26-4.81,9,9,0,0,1,3.55-3.41,10.17,10.17,0,0,1,5-1.25,10.61,10.61,0,0,1,5.34,1.41,18.32,18.32,0,0,1,5.26,5.2l-3.3,2.5a15.7,15.7,0,0,0-3.88-4,6.7,6.7,0,0,0-3.5-1,5.52,5.52,0,0,0-4,1.48A4.84,4.84,0,0,0,627,74.58a6.13,6.13,0,0,0,.55,2.55,9.2,9.2,0,0,0,2,2.69c.53.52,2.27,1.86,5.21,4q5.25,3.87,7.2,6.89a11.06,11.06,0,0,1,1.94,6.06,10.3,10.3,0,0,1-3.33,7.63,11.21,11.21,0,0,1-8.11,3.24,11.88,11.88,0,0,1-6.67-2A18.1,18.1,0,0,1,620.24,99.15Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.7,23h-.21a.18.18,0,0,1-.21-.16,3,3,0,0,0-.15-.31s0-.08,0-.11,0-.17,0-.26a.21.21,0,0,1,.1-.23,2.83,2.83,0,0,0,.25-.24l.66-.65a.05.05,0,0,0,0,0l.24-.45a.36.36,0,0,1,.15-.12.14.14,0,0,0,.08-.18c0-.17,0-.23.18-.24a.28.28,0,0,0,.23-.12.46.46,0,0,1,.21-.1.37.37,0,0,0,.22-.12,2.27,2.27,0,0,1,.28-.26.13.13,0,0,1,.08,0h.84c.18,0,.22.06.19.24a.09.09,0,0,0,.07.13,1.45,1.45,0,0,1,.29,0c.11,0,.22.08.33.12a1.43,1.43,0,0,0,.27.09.35.35,0,0,1,.23.12.28.28,0,0,0,.19.09.28.28,0,0,1,.27.2.7.7,0,0,0,.16.19s.11.05.14,0,.06-.09.07-.14,0-.18,0-.27.1-.16.22-.06a1.17,1.17,0,0,1,.15.16.18.18,0,0,0,.22.09c.12,0,.12-.06.08-.18a1.45,1.45,0,0,1,0-.3c0-.07,0-.14.13-.12a.12.12,0,0,1,.12.15s0,.08,0,.12,0,.09.06.1.08,0,.1,0a.33.33,0,0,1,.53,0,.12.12,0,0,0,.1,0,.49.49,0,0,1,.38-.12h.21a.11.11,0,0,0,.07-.08s0-.06,0-.09h0c-.07,0-.16-.07-.11-.17s.14-.07.22-.05a.22.22,0,0,1,.11.05.66.66,0,0,0,.49.14.25.25,0,0,1,.26.12s.09.07.1.06a.18.18,0,0,0,.08-.12,3.85,3.85,0,0,0,0-.48.46.46,0,0,1,.28-.43.22.22,0,0,0,.15-.22.18.18,0,0,1,0-.1s.06-.09.1-.09.07,0,.1.06a.87.87,0,0,1,.16.17c0,.06.06.13.1.2l.06.11.1-.07c.09-.11.16-.11.25,0s.08.13.19,0a.35.35,0,0,1,.22-.08c.16,0,.19,0,.2-.2s.05-.24.25-.24a.75.75,0,0,0,.15,0,.32.32,0,0,1,.3.15,1.67,1.67,0,0,1,.23.39,1.63,1.63,0,0,0,.27.33l.12.2c0,.07.08.13.12.21s.31.27.31.51a.22.22,0,0,0,.09.13.34.34,0,0,1,.13.22,1.86,1.86,0,0,0,.1.2l0,0c.09.2.19.41.29.61s.08.15.11.23a.65.65,0,0,1,.09.23.29.29,0,0,0,.11.21.36.36,0,0,1,.09.21.73.73,0,0,0,.14.37.57.57,0,0,1,.08.27.61.61,0,0,0,.11.28.6.6,0,0,1,.1.32.81.81,0,0,0,.14.43.5.5,0,0,1,.08.27c0,.15,0,.32.06.43a1.26,1.26,0,0,1,.16.78,1.41,1.41,0,0,0,.12.5,1.9,1.9,0,0,1,.09.58c0,.31,0,.61,0,.91a.71.71,0,0,0,.15.52s0,.09,0,.14c0,.4,0,.8,0,1.21,0,.06,0,.11-.08.17s0,.07-.05.11,0,.27,0,.4c0,.38,0,.76,0,1.14a2.66,2.66,0,0,1-.1.38,1.83,1.83,0,0,0-.09.39c0,.17,0,.35,0,.53a.2.2,0,0,1-.06.15.45.45,0,0,0-.13.36,2.62,2.62,0,0,1,0,.28,1.45,1.45,0,0,1-.11.26.71.71,0,0,0-.08.15,2.46,2.46,0,0,1,0,.26c0,.07-.05.17-.1.19a.5.5,0,0,1-.27,0c-.1,0-.08-.14,0-.21a.12.12,0,0,0,0-.18c-.1-.12-.18-.25-.28-.37a.24.24,0,0,0-.09-.08.37.37,0,0,1-.13-.31.13.13,0,0,1,0-.07.35.35,0,0,1,.43,0,.64.64,0,0,0,.13.1,1.11,1.11,0,0,0,.07-.16.29.29,0,0,0-.12-.28.42.42,0,0,1-.13-.41.8.8,0,0,0,0-.46,2.47,2.47,0,0,1-.22-.53c0-.08-.12-.06-.18,0s-.15,0-.19-.08v0c0-.27-.17-.44-.26-.66a1.07,1.07,0,0,0-.25-.31s-.11,0-.16,0-.12.06-.17.06-.18.05-.23.16a.48.48,0,0,1-.13.16l-.51.51a.49.49,0,0,1-.18.14c-.18.06-.21.08-.23.28l0,.56a.22.22,0,0,0,.12.22.42.42,0,0,1,.07.59s-.09,0-.1,0a.17.17,0,0,1-.1-.12c0-.1,0-.21,0-.31a.46.46,0,0,0-.07-.14l-.1.09c-.09.1-.16.11-.26,0a.57.57,0,0,1-.21-.41.21.21,0,0,0-.08-.16.34.34,0,0,1-.12-.28.45.45,0,0,0-.16-.4s-.05-.12-.05-.18,0-.32,0-.48-.05-.17-.18-.15a.33.33,0,0,1-.42-.29.25.25,0,0,0,0-.09l-.28-.27s-.07,0-.1,0h-.95a.31.31,0,0,0-.12.05.26.26,0,0,0,.05.12.46.46,0,0,1,0,.62,2.86,2.86,0,0,1-.36.41c-.14.12-.24.31-.47.31a.22.22,0,0,0-.14.09.23.23,0,0,1-.23.12.18.18,0,0,0-.21.11.23.23,0,0,1-.09.08l-.6.23a.67.67,0,0,0-.14.11.6.6,0,0,0,.16.08,1.85,1.85,0,0,0,.24,0,.5.5,0,0,0,.37-.14.2.2,0,0,1,.24,0c.08.05.08.12.07.2a3.57,3.57,0,0,1,0,.46.53.53,0,0,1-.08.17l-.13.21a1.43,1.43,0,0,1-.12.21,2.6,2.6,0,0,1-.26.32c-.12.13-.26.24-.39.36l-.3.3s0,0,0,.06a.31.31,0,0,0-.16.31.23.23,0,0,1-.11.16.23.23,0,0,0-.1.2c0,.1,0,.21,0,.31a.48.48,0,0,0,.13.32.3.3,0,0,1,.08.2c0,.25,0,.5,0,.74s-.06.31-.29.38a.24.24,0,0,0-.11.06l-.42.41a.28.28,0,0,0,0,.34c.19.17.17.34,0,.49a.47.47,0,0,0-.27.46.15.15,0,0,1,0,.11c-.09.11-.2.21-.29.33A.26.26,0,0,0,200,39a.43.43,0,0,1-.16.26,2,2,0,0,0-.22.27.35.35,0,0,1-.29.13H199a.52.52,0,0,0-.39.14.33.33,0,0,1-.45-.06s0,0,0,0c-.21-.11-.2-.3-.19-.48a.29.29,0,0,0-.1-.26.32.32,0,0,1-.1-.2c0-.09,0-.16-.12-.2a.23.23,0,0,1-.11-.22c0-.21,0-.43,0-.64a.33.33,0,0,0-.09-.21,1,1,0,0,1-.32-.64c0-.21,0-.42,0-.64a.76.76,0,0,1,.11-.22.82.82,0,0,0,.09-.19c0-.13,0-.25,0-.38a.48.48,0,0,0-.14-.37.58.58,0,0,1-.08-.3.3.3,0,0,0-.14-.29,1.48,1.48,0,0,1-.25-.25.21.21,0,0,1,0-.14c0-.24,0-.48.05-.72s-.07-.14-.15-.16-.1,0-.15,0a.27.27,0,0,1-.13-.07l-.3-.28a.16.16,0,0,0-.12,0,1.22,1.22,0,0,0-.27,0,.35.35,0,0,0-.16.09.31.31,0,0,1-.23.11l-1,0a.39.39,0,0,1-.38-.16,2.27,2.27,0,0,0-.31-.31,1.28,1.28,0,0,1-.11-.2,1.13,1.13,0,0,0-.12-.21l-.29-.33-.06-.07c-.05-.06-.14-.11-.15-.17a3.09,3.09,0,0,1,0-.43s0-.06.06-.08a.47.47,0,0,0,0-.63.31.31,0,0,1,0-.48.27.27,0,0,0,.08-.16.42.42,0,0,1,.12-.24.43.43,0,0,0,.09-.22.24.24,0,0,1,.12-.21s.05,0,.06-.05a.34.34,0,0,1,.32-.19.21.21,0,0,0,.12-.14,2.77,2.77,0,0,0,0-.3.4.4,0,0,1,.09-.17l.13-.18c.12-.15.22-.31.33-.47s.07-.1.06-.12a.26.26,0,0,0-.13-.08c-.24,0-.27-.07-.29-.26A.52.52,0,0,0,194,27c-.05-.06-.06-.11,0-.16a.29.29,0,0,0,.1-.25v-.46c0-.13.06-.19.19-.18s.49,0,.73,0a.14.14,0,0,0,.1-.05.38.38,0,0,0,0-.42l-.27-.23a.32.32,0,0,1-.06-.32c0-.11.13-.08.22-.08a1.57,1.57,0,0,0,.3,0s0-.05.06-.08-.05-.06-.08-.06l-.35,0c-.23,0-.3-.06-.37-.27a.35.35,0,0,0-.08-.13,1.1,1.1,0,0,0-.14.09.32.32,0,0,1-.34.08.29.29,0,0,1-.09-.15,1.71,1.71,0,0,1,0-.32s0,0,0,0a.76.76,0,0,1,.43-.43c.09,0,.15,0,.18-.13a.18.18,0,0,0-.08-.22.27.27,0,0,1-.09-.3c0-.05.08-.1.13-.13s.11,0,.16,0,.32,0,.39.16h0c.06.05.15.1.15.16s-.1.1-.14.16a.16.16,0,0,0,0,.12c.1.1.21.19.3.29a.29.29,0,0,1,.07.16.24.24,0,0,0,.15.22.14.14,0,0,1,.08.2c0,.08-.05.16,0,.21a.28.28,0,0,0,.27-.1s0-.07,0-.11a.32.32,0,0,1,.18-.22,1.13,1.13,0,0,1,.39-.21c.1,0,.09-.1,0-.18a.8.8,0,0,1-.13-.19.22.22,0,0,1,.11-.27s.06-.13.09-.19a.23.23,0,0,1,.27.14s.09.07.11,0,0-.22,0-.27a.42.42,0,0,0-.28-.07C196.71,22.78,196.69,22.87,196.7,23Zm6.58,6.63.15,0a.14.14,0,0,0,0-.11,1.88,1.88,0,0,0-.24-.25,2.31,2.31,0,0,1-.19-.14,1.59,1.59,0,0,1-.15-.21c0-.07-.09-.1-.16-.06s-.1.06-.09.08a1.59,1.59,0,0,0,.15.29c0,.08.11.14.14.21A.35.35,0,0,0,203.28,29.59ZM194.58,24h0s0,.06,0,.08a.54.54,0,0,0,0,.11s.09,0,.11-.08a.34.34,0,0,0,.05-.19c0-.05-.07-.09-.11-.13l-.1.1A.37.37,0,0,0,194.58,24Zm11.67-4.43c.05-.09.09-.15,0-.23a.11.11,0,0,0-.08,0C206.15,19.47,206.18,19.53,206.25,19.61ZM204,29.51s-.06-.06-.09-.07l-.06,0a.45.45,0,0,0,.07.07S203.94,29.53,204,29.51Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184.61,20.49c-.14-.12-.23-.11-.33,0s-.14.08-.22,0-.11-.09-.09-.18a.87.87,0,0,0,.06-.45.2.2,0,0,0-.19-.16.15.15,0,0,0-.18.11.14.14,0,0,1-.1.08.71.71,0,0,0-.22.32s0,.06,0,.08a.16.16,0,0,1,0,.25l-.28.25c-.05.05,0,.09,0,.13l.31.28c.07.07.05.3,0,.34s-.07,0-.1,0,0-.06-.06-.07a.16.16,0,0,0-.12,0s0,.07,0,.09l.09.06s.11.05.12.08a.19.19,0,0,1-.07.12c-.08.06-.14,0-.16-.06a.18.18,0,0,0-.19-.11h-.15a.19.19,0,0,1-.17-.2,1.09,1.09,0,0,0,0-.17c-.15.12-.27.23-.4.32a.4.4,0,0,1-.16.08.23.23,0,0,0-.19.19c0,.08-.1.14-.14.22a.48.48,0,0,0-.08.16.79.79,0,0,0,0,.22.25.25,0,0,0,.13.26.29.29,0,0,1,.1.19.21.21,0,0,0,.2.19h.2a.31.31,0,0,1,.25.14.35.35,0,0,0,.16.08.36.36,0,0,1,.26.13.36.36,0,0,0,.19.08c.17,0,.2,0,.25.19a2.26,2.26,0,0,0,.11.22c0,.09,0,.18.09.28a1,1,0,0,0,.08.14c0-.05.08-.09.09-.14s0-.32,0-.48a.22.22,0,0,1,.07-.17c.14-.06.14-.2.21-.31s0,0,0,0c-.1-.17,0-.4-.19-.56s0-.11,0-.16a.26.26,0,0,0,.1-.25,3.53,3.53,0,0,1,0-.46c0-.15.08-.2.23-.17l.49.07a.39.39,0,0,1,.11.06l.38.29a.19.19,0,0,1,.1.2c0,.21.16.29.28.4s.09,0,.12-.05.16-.19.25-.28.13-.05.19,0l.16.17a.56.56,0,0,1,.07.18.29.29,0,0,0,.12.23.34.34,0,0,1,.09.2.26.26,0,0,0,.12.23.16.16,0,0,1,.07.07.27.27,0,0,0,.25.13.22.22,0,0,1,.21.19c0,.08.09.15.13.23a.68.68,0,0,1,.07.2c0,.16,0,.33,0,.49a.36.36,0,0,0,0,.11c.09.11.2.21.28.33a.7.7,0,0,1,.09.24s0,.09-.07.11-.09,0-.11,0a.29.29,0,0,0-.29-.13c-.12,0-.24,0-.36,0s-.18,0-.23-.09a.36.36,0,0,1,.1-.34c.07,0,.12-.1.09-.19s-.06-.11-.15-.07a1.1,1.1,0,0,1-.26.06.22.22,0,0,0-.2.13l-.09.13a.44.44,0,0,0-.12.38c0,.11.07.17.19.17l.26,0c.09,0,.12,0,.16.08a.12.12,0,0,1-.05.17h0l-.49.26a.67.67,0,0,0-.14.09c-.15.11-.25.11-.37,0a.25.25,0,0,0-.41.08.88.88,0,0,0,0,.28c0,.12,0,.19-.15.2l-.3,0a.15.15,0,0,0-.15.14.64.64,0,0,1-.16.41.42.42,0,0,0-.07.23c0,.07,0,.13,0,.2s0,.23-.24.3a.82.82,0,0,0-.17.11l-.34.31a.28.28,0,0,0-.09.17.53.53,0,0,0,0,.25.44.44,0,0,0,.1.19.46.46,0,0,1,.08.59c0,.09-.17.1-.28,0s-.08-.12-.13-.18l-.13-.23A.49.49,0,0,1,183,29c0-.15,0-.19-.21-.2h-.38a.31.31,0,0,0-.29.14c0,.09-.12.08-.19,0s-.3-.17-.47,0a.42.42,0,0,1-.18.08c-.13,0-.2.08-.2.21,0,.37,0,.74,0,1.11a0,0,0,0,0,0,0,.69.69,0,0,0,.4.35h.26a.16.16,0,0,0,.17-.16c0-.23.05-.26.29-.28h.06c.1,0,.24,0,.29.09a.41.41,0,0,1-.06.42l-.05.06c-.11.19-.07.28.15.3a.75.75,0,0,0,.15,0,.25.25,0,0,1,.28.16s.06.05.07.08a.62.62,0,0,1,.1.22c0,.13,0,.27,0,.41s.07.24.24.25a.63.63,0,0,0,.19,0,.21.21,0,0,1,.25.09c.06.1.09.09.17,0s.2-.19.3-.29a.09.09,0,0,1,.05,0,.45.45,0,0,0,.34-.17c.07-.08.16,0,.24,0a1.51,1.51,0,0,0,.35.14,2,2,0,0,0,.73,0,.16.16,0,0,1,.13,0,3.2,3.2,0,0,1,.25.27l.09.1a3.26,3.26,0,0,1,.36.29.43.43,0,0,0,.3.14,1.23,1.23,0,0,1,.27,0,1,1,0,0,1,.23.11l.09.07c.13,0,.16.14.17.27a.3.3,0,0,0,.1.17.25.25,0,0,1,.1.21c0,.19,0,.22.21.23h.21a.23.23,0,0,1,.22.12h0a2.91,2.91,0,0,0,.62.29h.28a.25.25,0,0,1,.14.08.29.29,0,0,0,.25.14.2.2,0,0,1,.2.19,2.29,2.29,0,0,1,0,.74.11.11,0,0,1,0,.06l-.31.33a2.75,2.75,0,0,0-.19.28s0,0,0,.07a.38.38,0,0,1,0,.51.43.43,0,0,0-.07.2c0,.08,0,.16,0,.23s0,.13-.08.15a.3.3,0,0,0-.14.27c0,.13-.06.18-.19.19h-.15a.34.34,0,0,0-.33.14,2.68,2.68,0,0,1-.3.28.44.44,0,0,0-.09.18,1,1,0,0,0,0,.24.24.24,0,0,1-.11.22.16.16,0,0,0-.07.07l-.26.44c-.09.14-.18.28-.28.41a.41.41,0,0,1-.36.17c-.17,0-.2,0-.2.2v.21c0,.11-.06.16-.12.24a.62.62,0,0,1-.52.21.17.17,0,0,0-.19.19.24.24,0,0,1-.15.23.21.21,0,0,0-.08.16.82.82,0,0,1-.36.7c-.07.07-.08.11,0,.17a.27.27,0,0,1,0,.47.31.31,0,0,0-.09.18.3.3,0,0,1-.13.23.3.3,0,0,0-.08.08c-.13.18-.3.17-.46,0a1.92,1.92,0,0,0-.45-.29c-.15-.07-.18-.1-.18-.26s0-.33,0-.5a.23.23,0,0,1,.11-.13c.08-.06.11-.12.06-.2s0-.18.09-.24.11-.07,0-.18a.31.31,0,0,1-.07-.18c0-.25,0-.49,0-.74,0-.06.06-.12.09-.18s.09-.12.1-.18c0-.29,0-.58.05-.87,0-.06,0-.14,0-.17a.72.72,0,0,0,.14-.49v-.42a1.65,1.65,0,0,1,.1-.62.71.71,0,0,0-.21-.68,2.62,2.62,0,0,0-.65-.43.23.23,0,0,1-.09-.15c0-.08,0-.17,0-.25a1.74,1.74,0,0,0-.1-.19,1.09,1.09,0,0,1-.1-.25.36.36,0,0,0-.11-.23.61.61,0,0,1-.09-.2l-.13-.2c0-.06-.09-.12-.09-.18,0-.27,0-.54,0-.81v0c.14-.16.16-.4.35-.53a.19.19,0,0,0,.07-.13l0-.72s0-.07-.06-.11l-.09.1s0,.06,0,.09-.09.13-.2,0a.82.82,0,0,0-.19-.09.34.34,0,0,1-.26-.17c-.15-.21-.3-.41-.46-.61a.27.27,0,0,0-.17-.06.29.29,0,0,1-.24-.12.31.31,0,0,0-.18-.09.34.34,0,0,1-.25-.13,1.38,1.38,0,0,0-.28-.19l-.06,0a1.59,1.59,0,0,1-.3.06.31.31,0,0,1-.19-.09.24.24,0,0,0-.22-.1.26.26,0,0,1-.22-.11.33.33,0,0,0-.19-.11.29.29,0,0,1-.23-.13.08.08,0,0,0,0,0c-.19-.08-.2-.24-.19-.42a.29.29,0,0,0-.13-.29,2.68,2.68,0,0,1-.28-.3.61.61,0,0,0-.16-.09c0,.06,0,.12,0,.19s0,.07.06.1c-.14.1-.2.08-.3,0a2.41,2.41,0,0,1-.26-.39c-.08-.15-.22-.26-.21-.45,0,0,0,0,0,0a2.69,2.69,0,0,1-.3-.37.78.78,0,0,1-.09-.34.22.22,0,0,0-.16-.21,2.65,2.65,0,0,1-.4-.24.25.25,0,0,1-.08-.17.36.36,0,0,0-.11-.24.35.35,0,0,1-.1-.21.3.3,0,0,0-.12-.2.66.66,0,0,1-.15-.14l-.05-.07c-.13-.11-.13-.23,0-.37a.39.39,0,0,0,.06-.13c.06-.14.13-.29.19-.44a1.73,1.73,0,0,0,.07-.31c0-.17,0-.33,0-.5a.35.35,0,0,1,.08-.22.56.56,0,0,0,.13-.35v-.26a.49.49,0,0,1,.11-.28.86.86,0,0,0,.1-.32.75.75,0,0,1,.14-.45c.06-.06,0-.18.08-.27l.09-.24c0-.12.1-.24.13-.36a.44.44,0,0,1,.11-.24.31.31,0,0,0,.09-.18.35.35,0,0,1,.13-.27s0-.13.08-.19l.12-.24c0-.07.07-.13.09-.19a.38.38,0,0,1,.13-.24.34.34,0,0,0,.09-.2.3.3,0,0,1,.12-.21.5.5,0,0,0,.11-.17l.12-.23c.09-.17.28-.28.31-.5a.21.21,0,0,1,.07-.12.81.81,0,0,1,.16-.16s.09-.07.12-.06.06.06.08.1a.17.17,0,0,1,0,.07c0,.18,0,.21.21.23s.21.07.2.24a.43.43,0,0,1-.29.43s0,.06-.07.09.06.07.09.07h.41c.1,0,.16-.06.11-.17a.19.19,0,0,1,.07-.23,1.12,1.12,0,0,0,.27-.26.53.53,0,0,0,0-.28s-.11-.07-.17-.08a.3.3,0,0,1-.26-.12c0-.05-.11-.06-.17-.09s-.19-.05-.2-.09a.48.48,0,0,1,0-.26.5.5,0,0,1,.13-.19.33.33,0,0,1,.17-.12.92.92,0,0,1,.33,0,.44.44,0,0,1,.2.11c.06.06.09.06.12,0v0c.1-.19.1-.19-.08-.29a.16.16,0,0,1,0-.27.39.39,0,0,0,.11-.15.15.15,0,0,0-.07-.21c-.12-.07-.11-.13,0-.23a3.64,3.64,0,0,0,.34-.34l.3-.3.36-.36.31-.3.32-.3.45-.34c.13-.1.27-.2.39-.31a.29.29,0,0,1,.21-.11h1.3a.66.66,0,0,1,.27.09.34.34,0,0,0,.37,0,.2.2,0,0,1,.2,0,1.83,1.83,0,0,0,.48.25,1.81,1.81,0,0,0,.52,0s.08,0,.11-.09.12-.08.18,0a.28.28,0,0,0,.25.11.2.2,0,0,0,.19-.1.18.18,0,0,1,.2-.11h.18a.27.27,0,0,0,.28-.13c0-.06.13-.09.19-.1.29,0,.58,0,.86,0a.7.7,0,0,0,.2-.08c.07,0,.14-.09.21-.09h1.37a.24.24,0,0,1,.16.09.24.24,0,0,0,.21.11.32.32,0,0,1,.25.12.25.25,0,0,0,.18.08c.17,0,.21.06.22.22s0,.23.24.23a.67.67,0,0,0,.2,0,.46.46,0,0,0,.17-.09.26.26,0,0,1,.24-.12h.28c.11,0,.16.07.17.17s0,.19-.08.26a1.92,1.92,0,0,0-.34.3c-.13.12-.24.24-.36.36a2.2,2.2,0,0,0-.26.27s0,.09,0,.13l.28.28a.23.23,0,0,1-.12.39h0l-.14.08.1.11a2.39,2.39,0,0,1,.23.22c.07.09,0,.17-.06.22a1.31,1.31,0,0,0-.12.11,2.34,2.34,0,0,1-.31.32.28.28,0,0,0-.1.21c0,.17,0,.36.11.5s0,.05,0,.06-.16.28-.34.35a2.52,2.52,0,0,0-.44.31.37.37,0,0,1-.18.08h-.28a.85.85,0,0,0-.54.25,3.45,3.45,0,0,0-.23.28.41.41,0,0,1-.22.1.37.37,0,0,0-.27.13c0,.05-.13.07-.2.08s-.2.05-.2.22a1.2,1.2,0,0,0,0,.19.25.25,0,0,1-.12.24.28.28,0,0,0-.09.18,1.11,1.11,0,0,0,0,.26.32.32,0,0,1-.4.25c-.12-.05-.24-.12-.37-.19l-.12-.05-.21-.15L188,21.9a.5.5,0,0,1-.1-.11c-.1-.2-.18-.4-.28-.6a.76.76,0,0,0-.08-.11.33.33,0,0,1-.07-.16,4.87,4.87,0,0,1,0-.54.26.26,0,0,1,.13-.24s.06-.07,0-.09,0,0-.08-.06h-.07c-.2,0-.24-.06-.24-.26s.06-.19.2-.22l.16-.07a.56.56,0,0,0-.16-.07l-.25,0c-.13,0-.16-.11-.06-.2s.08-.15,0-.24a.46.46,0,0,1-.09-.23,1.18,1.18,0,0,0-.14-.37,2.41,2.41,0,0,0-.34-.37.18.18,0,0,0-.13-.06h-1.14a.26.26,0,0,1-.12-.05,1.84,1.84,0,0,1-.25-.23.18.18,0,0,1,0-.16c.05-.11,0-.16-.1-.2s-.19-.1-.14-.29a.2.2,0,0,1,.19-.17c.17,0,.34,0,.51,0a.34.34,0,0,0,.15-.09,1.37,1.37,0,0,0,.13-.2l-.08,0a.32.32,0,0,1-.27-.19c0-.08-.1-.07-.16,0l-.27.29a.28.28,0,0,1-.15.06,1.36,1.36,0,0,1-.2,0,.23.23,0,0,0-.18.2,1.37,1.37,0,0,1-.07.29.2.2,0,0,1-.21.14c-.18,0-.2,0-.21.22a1.64,1.64,0,0,1,0,.22.37.37,0,0,1-.11.18.22.22,0,0,0-.1.23.22.22,0,0,1-.12.24.16.16,0,0,0-.06.09.13.13,0,0,0,.09.06.89.89,0,0,1,.57.37c.07.08.17.13.25.21s.1.13.16.19l.14.08.24,0a.3.3,0,0,1,.23.13.36.36,0,0,0,.15.1.4.4,0,0,1,.28.4c0,.12,0,.18.13.27a1.57,1.57,0,0,0,.4.29,1.51,1.51,0,0,0,.22.11c.12.06.12.13,0,.22s-.29.29-.43.44,0,.11,0,.17.09.23-.1.27a.33.33,0,0,0-.18.08.51.51,0,0,1-.6,0l-.24-.14s-.06,0-.06,0-.16-.17-.25-.25a.25.25,0,0,0-.36,0l0,.05c-.11.06-.19,0-.22-.09s0-.32.23-.31.26-.12.35-.24A2.75,2.75,0,0,0,184.61,20.49Zm-3.09-1.42c0,.2.18.29.28.43s.14.17.13.3a.14.14,0,0,0,.13.15c.09,0,.2,0,.25.06s.05.17.07.25a.14.14,0,0,0,.08.09s.06,0,.09-.06.06-.09.11-.12a.21.21,0,0,0,.09-.26c0-.1-.1-.12-.17-.15a.63.63,0,0,1-.27-.14c-.1-.08-.16-.2-.25-.28a.27.27,0,0,1,0-.46s0-.07.07-.1a.41.41,0,0,1,.11-.12.28.28,0,0,0,.1-.3.14.14,0,0,0-.11-.07s-.12.06-.12.08c.06.18-.08.28-.16.41s-.07.12-.15.12h-.15A.13.13,0,0,0,181.52,19.07Zm.47-.71s-.06-.06-.09-.07a.25.25,0,0,1-.22-.31s-.05-.07-.08-.11-.06.07-.07.11,0,.21-.05.32a.15.15,0,0,0,0,.08A.46.46,0,0,0,182,18.36Zm.26-.58c0,.14,0,.18.14.22a1.11,1.11,0,0,0,.26,0s.07-.05.11-.08-.07-.07-.11-.08a.32.32,0,0,0-.14,0Zm-3.14,11.64h0s0-.08,0-.12,0,0-.07-.06-.05,0-.06.07a1.34,1.34,0,0,0,0,.2.11.11,0,0,0,.08.05s0,0,.05-.06S179.11,29.44,179.11,29.42ZM181.21,19h0c-.07.07,0,.16,0,.25s0,0,0,0,0,0,0,0A1.79,1.79,0,0,0,181.21,19Zm1.72-.54h0s0,.06,0,.09,0,.06.05.09.06,0,.06-.07A.61.61,0,0,0,182.93,18.43Zm.39,1.33s-.06.08,0,.1,0,0,.08.06l0-.05A.9.9,0,0,0,183.32,19.76Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M197.53,16.3h.21a.27.27,0,0,0,.27-.12.22.22,0,0,1,.16-.07h.94c.14,0,.19.08.23.27s-.06.14-.13.17l-.05,0a.43.43,0,0,1-.4.2.09.09,0,0,0-.06.06.13.13,0,0,0,0,.09l.19,0c.11.05.13.11.06.21l-.05.06a.26.26,0,0,1-.49-.06l0-.12c-.05-.09-.11-.09-.16,0l-.24.45a.27.27,0,0,1-.4.05,1.75,1.75,0,0,1-.19-.2.49.49,0,0,1-.06-.17c0-.17,0-.2-.21-.2s-.23-.06-.22-.24a1.93,1.93,0,0,0,0-.24c0-.11.06-.17.16-.18l.44,0Zm1,.45a.76.76,0,0,0,.07-.09.34.34,0,0,0-.09-.08s-.06,0-.06.05A.35.35,0,0,0,198.55,16.75Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.37,17.36l.22,0a.16.16,0,0,1,.1.08s0,.07-.06.11,0,0,0,0a.43.43,0,0,1-.42.21.14.14,0,0,0-.1.05.45.45,0,0,1-.34.15.91.91,0,0,0-.3.14c-.17.11-.28.31-.5.34,0,0-.09.07-.11.12a1.54,1.54,0,0,0-.12.34.56.56,0,0,0,0,.22.94.94,0,0,0,.06.15c0,.08,0,.13-.06.17a.39.39,0,0,1-.4-.07.45.45,0,0,0-.21-.1c-.21-.05-.27-.2-.13-.37s.21-.24.31-.37a.69.69,0,0,0,0-.17.67.67,0,0,1,.11-.18,2.83,2.83,0,0,1,.3-.3,5,5,0,0,1,.47-.33.36.36,0,0,1,.18,0h.36a.36.36,0,0,0,.29-.13c.07-.07.2-.08.3-.12Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203,36.25a.32.32,0,0,1-.12.25.19.19,0,0,0-.07.14c0,.16,0,.32,0,.48a.58.58,0,0,1-.12.36.48.48,0,0,0-.09.27.29.29,0,0,1-.12.24.34.34,0,0,0-.08.09.3.3,0,0,1-.34.1c-.11,0-.12-.12-.15-.21a1.17,1.17,0,0,0-.09-.24.37.37,0,0,1,0-.39.34.34,0,0,0,.08-.21,3.49,3.49,0,0,0,0-.46c0-.16,0-.21.2-.23a.36.36,0,0,0,.24-.13.6.6,0,0,0,.22-.38c0-.11.11-.13.18-.06a.81.81,0,0,1,.19.18A1.19,1.19,0,0,1,203,36.25Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.64,21.48h0c-.26.06-.42-.11-.54-.3a.64.64,0,0,1-.05-.49c0-.1.13-.11.19,0a.3.3,0,0,0,.32.14c.12,0,.25,0,.34-.11a.14.14,0,0,1,.23,0,3.32,3.32,0,0,1,.38.37c.06.06,0,.14,0,.19a1.8,1.8,0,0,1-.31.2,2.44,2.44,0,0,1-.46.07Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.39,30.26l-.4,0c-.09,0-.11-.07-.05-.16s.16-.27.34-.25.13,0,.16.06a.62.62,0,0,0,.35.16c.09,0,.17.09.26.12a.84.84,0,0,0,.25.09.3.3,0,0,1,.21.13.46.46,0,0,0,.14.07h.08a.58.58,0,0,1,.59.25c.06.08,0,.18-.07.19h-.63c-.1,0-.14-.1-.15-.2s0-.2-.22-.19-.34,0-.43-.18a.26.26,0,0,0-.13-.06,2.8,2.8,0,0,0-.29,0Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.48,15.89h.28c.15,0,.2.09.14.22a.42.42,0,0,1-.51.2A2.16,2.16,0,0,0,202,16s0-.1.05-.11l.23,0h.25Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204,16v.07c0,.1,0,.2-.1.25a.35.35,0,0,1-.35-.1s-.1-.09-.14-.14a.18.18,0,0,1,0-.13,2,2,0,0,1,.39-.26c.14-.06.22,0,.23.18V16Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.86,15.67c.12,0,.2,0,.2.13s0,.26-.14.29l-.3,0a.86.86,0,0,0-.23.05c-.09,0-.13,0-.16-.06s0-.21.07-.21a.57.57,0,0,0,.44-.2S204.83,15.68,204.86,15.67Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.9,18.12c-.06.05-.11.12-.15.12s-.11-.09-.1-.12.07-.11.11-.17Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184.14,30.77c-.08.05-.12.1-.17.1a.1.1,0,1,1,0-.2S184.06,30.72,184.14,30.77Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.82,30.77c-.06.06-.1.12-.14.11s-.08-.06-.11-.1.06-.1.09-.1S185.75,30.73,185.82,30.77Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.53,21.85c.05.07.1.1.11.15s-.06.09-.09.09-.1-.05-.1-.09S183.49,21.92,183.53,21.85Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 537.32,
    y1: 94.88,
    x2: 547.69,
    y2: 87.66
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 535.44,
    y1: 85.13,
    x2: 547.69,
    y2: 87.66
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 543.69,
    y1: 101.88,
    x2: 551.8,
    y2: 99.21
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 559.75,
    y1: 103.29,
    x2: 551.8,
    y2: 99.21
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 537.32,
    y1: 94.88,
    x2: 551.8,
    y2: 99.21
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.69,
    y1: 87.66,
    x2: 549.69,
    y2: 77.43
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 535.44,
    y1: 85.13,
    x2: 549.69,
    y2: 77.43
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 551.8,
    y1: 99.21,
    x2: 547.69,
    y2: 87.66
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 562.47,
    y1: 91.27,
    x2: 547.69,
    y2: 87.66
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 561.58,
    y1: 80.55,
    x2: 547.69,
    y2: 87.66
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 562.47,
    y1: 91.27,
    x2: 561.58,
    y2: 80.55
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 549.69,
    y1: 77.43,
    x2: 561.58,
    y2: 80.55
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 540.97,
    y1: 71.82,
    x2: 549.69,
    y2: 77.43
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.98,
    y1: 68.8,
    x2: 549.69,
    y2: 77.43
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 561.58,
    y1: 80.55,
    x2: 555.98,
    y2: 68.8
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 568.68,
    y1: 76.95,
    x2: 561.58,
    y2: 80.55
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 562.47,
    y1: 91.27,
    x2: 568.68,
    y2: 76.95
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 572.02,
    y1: 88.55,
    x2: 562.47,
    y2: 91.27
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 567.83,
    y1: 98.49,
    x2: 562.47,
    y2: 91.27
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 551.8,
    y1: 99.21,
    x2: 562.47,
    y2: 91.27
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 559.75,
    y1: 103.29,
    x2: 562.47,
    y2: 91.27
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWodcom);
export default __webpack_public_path__ + "static/media/logo-wodcom.1522c9ca.svg";
export { ForwardRef as ReactComponent };